import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from './../../../../environments/environment';
import { Subscription } from 'rxjs';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

@Component({
  selector: 'app-other-product',
  templateUrl: './other-product.component.html',
  styles: [
  ]
})
export class OtherProductComponent implements OnInit {
  
  dataTitle;
  dataSection = [];
  apiAsset = environment.API_ASSETS;
  paramsSubscription:Subscription;
  isLang;
   
  constructor(private apiService: ApiService, 
              private activedRoute: ActivatedRoute,
              private globalService: GlobalService,
              private router: Router) {
    this.globalService.isLoading.next(true);  
  }

  ngOnInit(): void {
    // Content
    this.paramsSubscription = this.activedRoute.params.subscribe(params => {
      this.globalService.isLoading.next(true);
      this.apiService.getDataApi('getProductSection?slug=other/'+params['slug']).subscribe(response => {
        if(response.success) {
          this.dataTitle = response.data;
          this.dataSection = response.data.section;
          // Meta
          this.globalService.updateMeta(
            response.data.title + ' | Prime Agri Resources',
            response.data.keyword,
            response.data.metadesc
          );
          this.globalService.isLoading.next(false);
        }else{
          this.router.navigate(['/not-found']);
        }
      });
    });
  }

  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
  }

}
